import { LmDatepickerProvider } from "./DatepickerProvider";
import {
  START_DATE,
  useDatepicker
} from "@datepicker-react/hooks";
import { useId, useState } from "react";
import { Input, useMedia, XGroup, XStack } from "tamagui";
import { usePopoverState } from "@tamagui-extras/core";
import { getLocaleDate } from "../dateHelper";
import { LmFormFieldContainer } from "@tamagui-extras/form";
import { Platform } from "react-native-web";
import { LmDatepickerPopover } from "./LmDatepickerPopover";
import { jsx, jsxs } from "react/jsx-runtime";
function LmDatepicker({
  numberOfMonths,
  isRangePicker,
  onChange,
  labelFunctions,
  startDate = null,
  endDate = null,
  required,
  error,
  helperText,
  helperTextProps,
  label,
  labelProps,
  labelInline,
  fullWidth,
  inputProps,
  buttonProps,
  popoverProps,
  containerProps
}) {
  const id = useId(), media = useMedia(), popoverState = usePopoverState(!1), [state, setState] = useState({
    startDate,
    endDate,
    focusedInput: START_DATE
  }), monthsCount = isRangePicker ? media.xs ? 1 : numberOfMonths ?? 2 : 1, { activeMonths, firstDayOfWeek, ...context } = useDatepicker({
    startDate: state.startDate,
    endDate: state.endDate,
    focusedInput: state.focusedInput,
    onDatesChange: (data) => {
      data.focusedInput ? setState(data) : setState({ ...data, focusedInput: START_DATE }), typeof onChange == "function" && onChange(data), isRangePicker || popoverState.onOpenChange(!1);
    },
    numberOfMonths: monthsCount,
    ...!isRangePicker && {
      minBookingDays: 1,
      exactMinBookingDays: !0
    }
  }), getInputValue = isRangePicker ? `${getLocaleDate({ date: state.startDate })}${state.endDate ? " - " + getLocaleDate({ date: state.endDate }) : ""}` : getLocaleDate({ date: state.startDate });
  return /* @__PURE__ */ jsx(LmDatepickerProvider, { ...context, children: /* @__PURE__ */ jsx(
    LmFormFieldContainer,
    {
      id,
      error,
      required,
      labelProps,
      label,
      labelInline,
      helperText,
      helperTextProps,
      fullWidth,
      ...containerProps,
      children: /* @__PURE__ */ jsx(
        XStack,
        {
          space: !0,
          ...fullWidth ? {
            flexGrow: 1
          } : {
            width: Platform.OS === "web" ? "100%" : void 0
          },
          children: /* @__PURE__ */ jsxs(XGroup, { flexGrow: fullWidth ? 1 : void 0, alignItems: "center", flexDirection: "row", children: [
            /* @__PURE__ */ jsx(XGroup.Item, { children: /* @__PURE__ */ jsx(
              Input,
              {
                width: "100%",
                minWidth: isRangePicker ? "$16" : void 0,
                value: getInputValue,
                onPressIn: () => popoverState.onOpenChange(!0),
                ...inputProps
              }
            ) }),
            /* @__PURE__ */ jsx(XGroup.Item, { children: /* @__PURE__ */ jsx(
              LmDatepickerPopover,
              {
                activeMonths,
                monthsCount,
                firstDayOfWeek,
                labelFunctions,
                buttonProps,
                ...popoverState,
                ...popoverProps
              }
            ) })
          ] })
        }
      )
    }
  ) });
}
export {
  LmDatepicker
};
//# sourceMappingURL=LmDatepicker.js.map
